











































import { Component, Vue, Prop } from 'vue-property-decorator';
import dayjs from 'dayjs';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import FormInput from '@/components/FormInput.vue';
import Button from '@/components/Button.vue';
import CalendarIcon from '@/assets/calendar.svg';

export interface DateRange {
  startDate: null | string;
  endDate: null | string;
}

@Component({
  components: {
    DateRangePicker,
    FormInput,
    Button,
    CalendarIcon,
  },
})
export default class SingleDatePicker extends Vue {
  @Prop(Object) value!: DateRange;
  @Prop({ type: String, default: 'Select date' }) placeholder!: string;

  clearDate(closeFunc: Function) {
    this.$emit('input', {
      startDate: null,
      endDate: null,
    });

    closeFunc();
  }

  get inputVal() {
    return this.value;
  }

  set inputVal(val) {
    let start = null;
    let end = null;

    if (val.startDate) {
      // console.log(dayjs(val.startDate).toDate().toString());
      start = dayjs(val.startDate).toDate().toString();
    }

    if (val.endDate) {
      end = dayjs(val.endDate).hour(0).toDate().toString();
    }

    this.$emit('input', {
      startDate: start,
      endDate: end,
    });
  }

  // eslint-disable-next-line class-methods-use-this
  get maxDate() {
    const today = dayjs().hour(0).minute(0).second(0)
      .subtract(1, 'day');
    return today.toDate();
  }

  // eslint-disable-next-line class-methods-use-this
  get ranges() {
    const today = dayjs().hour(0).minute(0).second(0);

    const yesterday = dayjs().hour(0).minute(0).second(0)
      .subtract(1, 'day');

    const thisWeekStart = dayjs().startOf('week');
    const thisWeekEnd = dayjs().endOf('week');

    const lastWeekStart = thisWeekStart.subtract(1, 'week');
    const lastWeekEnd = lastWeekStart.endOf('week');

    const thisMonthStart = dayjs().startOf('month');
    const thisMonthEnd = dayjs().endOf('month');

    const lastMonthStart = thisMonthStart.subtract(1, 'month');
    const lastMonthEnd = lastMonthStart.endOf('month');

    return {
      Today: [today.toDate(), today.toDate()],
      Yesterday: [yesterday.toDate(), yesterday.toDate()],
      'This Week': [thisWeekStart.toDate(), thisWeekEnd.toDate()],
      'Last Week': [lastWeekStart.toDate(), lastWeekEnd.toDate()],
      'This Month': [thisMonthStart.toDate(), thisMonthEnd.toDate()],
      'Last Month': [lastMonthStart.toDate(), lastMonthEnd.toDate()],
    };
  }

  get startDate() {
    if (this.inputVal.startDate === null) return '';
    console.log(this.inputVal.startDate);
    return dayjs(this.inputVal.startDate).format('DD/MM/YYYY HH:mm:ss');
  }

  get endDate() {
    if (this.inputVal.endDate === null) return '';
    return dayjs(this.inputVal.endDate).format('DD/MM/YYYY');
  }

  get selectedDateRange() {
    if (this.inputVal.startDate === null || this.inputVal.endDate === null) return '';
    return `${this.startDate}`;
  }
}
